import initialCurrentState from './initialCurrentState';

export default {
    saving: false,
    loadedState: { ...initialCurrentState },
    current: { ...initialCurrentState },
};
